import React from 'react';
import { render } from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
// eslint-disable-next-line import/no-unassigned-import
import {} from '@im/im-theme/themeAugmentation';
import { extend as extendDayJs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import './index.css';

extendDayJs(utc);

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
